export default __webpack_public_path__ + "static/media/resume.3ddd20c9.pdf";